import script from "./OrderTemplateListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderTemplateListPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrderTemplateListPage.vue?vue&type=style&index=0&id=0df86e8c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df86e8c"]])

export default __exports__